export const FETCH_ADJUSTMENT_PERIODS = 'FETCH_ADJUSTMENT_PERIODS';
export const FETCH_ADJUSTMENT_PERIODS_SUCCESS = 'FETCH_ADJUSTMENT_PERIODS_SUCCESS';
export const FETCH_ADJUSTMENT_PERIODS_FAILURE = 'FETCH_ADJUSTMENT_PERIODS_FAILURE';

export const FETCH_COMPANY_CODES_FOR_BEGINNING_BALANCES = 'FETCH_COMPANY_CODES_FOR_BEGINNING_BALANCES';
export const FETCH_COMPANY_CODES_FOR_BEGINNING_BALANCES_SUCCESS = 'FETCH_COMPANY_CODES_FOR_BEGINNING_BALANCES_SUCCESS';
export const FETCH_COMPANY_CODES_FOR_BEGINNING_BALANCES_FAILURE = 'FETCH_COMPANY_CODES_FOR_BEGINNING_BALANCES_FAILURE';

export const FETCH_CONNECTIONS_FOR_BEGINNING_BALANCES = 'FETCH_CONNECTIONS_FOR_BEGINNING_BALANCES';
export const FETCH_CONNECTIONS_FOR_BEGINNING_BALANCES_SUCCESS = 'FETCH_CONNECTIONS_FOR_BEGINNING_BALANCES_SUCCESS';
export const FETCH_CONNECTIONS_FOR_BEGINNING_BALANCES_FAILURE = 'FETCH_CONNECTIONS_FOR_BEGINNING_BALANCES_FAILURE';

export const FETCH_BEGINNING_BALANCE_FOR_COMPANY_CODE = 'FETCH_BEGINNING_BALANCE_FOR_COMPANY_CODE';
export const FETCH_BEGINNING_BALANCE_FOR_COMPANY_CODE_SUCCESS = 'FETCH_BEGINNING_BALANCE_FOR_COMPANY_CODE_SUCCESS';
export const FETCH_BEGINNING_BALANCE_FOR_COMPANY_CODE_FAILURE = 'FETCH_BEGINNING_BALANCE_FOR_COMPANY_CODE_FAILURE';

export const FETCH_COMPANY_CODES_FOR_CONNECTION_BEGINNING_BALANCES
  = 'FETCH_COMPANY_CODES_FOR_CONNECTION_BEGINNING_BALANCES';
export const FETCH_COMPANY_CODES_FOR_CONNECTION_BEGINNING_BALANCES_SUCCESS
  = 'FETCH_COMPANY_CODES_FOR_CONNECTION_BEGINNING_BALANCES_SUCCESS';
export const FETCH_COMPANY_CODES_FOR_CONNECTION_BEGINNING_BALANCES_FAILURE
  = 'FETCH_COMPANY_CODES_FOR_CONNECTION_BEGINNING_BALANCES_FAILURE';

export const FETCH_BEGINNING_BALANCE_IMPORT_DATA = 'FETCH_BEGINNING_BALANCE_IMPORT_DATA';
export const FETCH_BEGINNING_BALANCE_IMPORT_DATA_SUCCESS = 'FETCH_BEGINNING_BALANCE_IMPORT_DATA_SUCCESS';
export const FETCH_BEGINNING_BALANCE_IMPORT_DATA_FAILURE = 'FETCH_BEGINNING_BALANCE_IMPORT_DATA_FAILURE';

export const SELECT_ADJUSTMENT_PERIOD = 'SELECT_ADJUSTMENT_PERIOD';
export const SELECT_CONNECTION_FOR_BEGINNING_BALANCES = 'SELECT_CONNECTION_FOR_BEGINNING_BALANCES';
export const SELECT_COMPANY_CODE_FOR_BEGINNING_BALANCES = 'SELECT_COMPANY_CODE_FOR_BEGINNING_BALANCES';
export const SELECT_COMPANY_CODE_FOR_BEGINNING_BALANCES_CONNECTION
  = 'SELECT_COMPANY_CODE_FOR_BEGINNING_BALANCES_CONNECTION';

export const UPLOAD_BEGINING_BALANCES_FILE = 'UPLOAD_BEGINING_BALANCES_FILE';
export const UPLOAD_BEGINING_BALANCES_FILE_SUCCESS = 'UPLOAD_BEGINING_BALANCES_FILE_SUCCESS';
export const UPLOAD_BEGINING_BALANCES_FILE_FAILURE = 'UPLOAD_BEGINING_BALANCES_FILE_FAILURE';
